/**
 * Плагины ModelerX6: фабрика и набор плагинов по одному файлу.
 *
 * Отправка патчей в сокет — только из подписок на события графа (и кастомные события на graph).
 * При первом рендере и при размонтировании ячейки добавляются/удаляются с options.silent, события не эмитятся.
 *
 * События графа → патч:
 *   node:mousedown / edge:mousedown         → lock.acquire, включая вложенные узлы (objectLockPlugin)
 *   node:change:position, cell:change:size  → live + persist on release (nodeChangePatchPlugin)
 *   node:embedded, node:change:parent         → updateNode parentNodeId (nodeEmbeddedPlugin)
 *   node:removed                           → removeNode (nodeRemovedPlugin)
 *   node:added-to-view (custom)            → addNode (viewNodeAddedPatchPlugin)
 *   connection:added-to-view (custom)      → addConnection (viewConnectionAddedPatchPlugin)
 *   node:dblclick, cell:dblclick           → updateElementLabel (nodeDblclickPlugin)
 *   history:undo / history:redo (attrs подписи) → updateElementLabel (historyNodeLabelPatchPlugin)
 *   edge:connected                        → addConnection (edgeConnectedPlugin; переподключение существующего edge — только edgeTerminalChangePlugin)
 *   edge:added (+ _fromUserConnection)    → addConnection (edgeAddedPatchPlugin)
 *   edge:removed                          → removeConnection (edgeRemovedPlugin)
 *   edge:change:vertices                  → live; persist on pointerup via vertex batches, or сразу при dblclick (edgeVerticesPlugin)
 *   batch:stop add/move-vertex|move-segment|move-selection → updateConnection bendpoints (edgeVerticesPlugin)
 *   edge:added / edge:change:parent       → снять встраивание ребра в ноду (edgeKeepRootPlugin);
 *                                           массово — в конце renderView до patch-sync
 *   cell:change:source/target              → updateConnection (edgeTerminalChangePlugin)
 *   connection:relationship:updated (custom) → updateRelationship (connectionRelationshipUpdatedPlugin)
 *   connection:label:updated (custom)     → updateConnectionLabel (connectionLabelUpdatedPlugin)
 *   (PropertiesModal commitChanges → modeling.updateProperties) → updateElementProperties (в ModelerX6._updateConceptProperties)
 *   keydown Ctrl|Meta+C / V на контейнере графа → копирование/вставка узлов (boardCopyPastePlugin)
 */
export {default as PluginFactory} from './PluginFactory';
export {default as objectLockPlugin} from './objectLockPlugin';
export {default as nodeChangePatchPlugin} from './nodeChangePatchPlugin';
export {default as nodeResizePlugin} from './nodeResizePlugin';
export {default as cellClickPlugin} from './cellClickPlugin';
export {default as nodeEmbeddedPlugin} from './nodeEmbeddedPlugin';
export {default as viewNodeAddedPatchPlugin} from './viewNodeAddedPatchPlugin';
export {default as viewConnectionAddedPatchPlugin} from './viewConnectionAddedPatchPlugin';
export {default as edgeConnectedPlugin} from './edgeConnectedPlugin';
export {default as edgeAddedPatchPlugin} from './edgeAddedPatchPlugin';
export {default as edgeRemovedPlugin} from './edgeRemovedPlugin';
export {default as nodeRemovedPlugin} from './nodeRemovedPlugin';
export {default as edgeVerticesPlugin} from './edgeVerticesPlugin';
export {default as edgeKeepRootPlugin} from './edgeKeepRootPlugin';
export {default as edgeTerminalChangePlugin} from './edgeTerminalChangePlugin';
export {default as connectionRelationshipUpdatedPlugin} from './connectionRelationshipUpdatedPlugin';
export {default as connectionLabelUpdatedPlugin} from './connectionLabelUpdatedPlugin';
export {default as nodeDblclickPlugin} from './nodeDblclickPlugin';
export {default as historyNodeLabelPatchPlugin} from './historyNodeLabelPatchPlugin';
export {default as edgeDblclickPlugin} from './edgeDblclickPlugin';
export {default as connectionStartFromPlugin} from './connectionStartFromPlugin';
export {default as connectToolPlugin} from './connectToolPlugin';
export {default as boardCopyPastePlugin} from './boardCopyPastePlugin';

import objectLockPlugin from './objectLockPlugin';
import nodeChangePatchPlugin from './nodeChangePatchPlugin';
import nodeResizePlugin from './nodeResizePlugin';
import cellClickPlugin from './cellClickPlugin';
import nodeEmbeddedPlugin from './nodeEmbeddedPlugin';
import viewNodeAddedPatchPlugin from './viewNodeAddedPatchPlugin';
import viewConnectionAddedPatchPlugin from './viewConnectionAddedPatchPlugin';
import edgeConnectedPlugin from './edgeConnectedPlugin';
import edgeAddedPatchPlugin from './edgeAddedPatchPlugin';
import edgeRemovedPlugin from './edgeRemovedPlugin';
import nodeRemovedPlugin from './nodeRemovedPlugin';
import edgeVerticesPlugin from './edgeVerticesPlugin';
import edgeKeepRootPlugin from './edgeKeepRootPlugin';
import edgeTerminalChangePlugin from './edgeTerminalChangePlugin';
import connectionRelationshipUpdatedPlugin from './connectionRelationshipUpdatedPlugin';
import connectionLabelUpdatedPlugin from './connectionLabelUpdatedPlugin';
import nodeDblclickPlugin from './nodeDblclickPlugin';
import historyNodeLabelPatchPlugin from './historyNodeLabelPatchPlugin';
import edgeDblclickPlugin from './edgeDblclickPlugin';
import connectionStartFromPlugin from './connectionStartFromPlugin';
import connectToolPlugin from './connectToolPlugin';
import boardCopyPastePlugin from './boardCopyPastePlugin';

/**
 * Регистрирует все плагины по умолчанию в переданной фабрике.
 * @param {import('./PluginFactory').default} pluginFactory
 */
export function registerDefaultPlugins(pluginFactory) {
	pluginFactory.register(objectLockPlugin);
	pluginFactory.register(nodeChangePatchPlugin);
	pluginFactory.register(nodeResizePlugin);
	pluginFactory.register(cellClickPlugin);
	pluginFactory.register(nodeEmbeddedPlugin);
	pluginFactory.register(viewNodeAddedPatchPlugin);
	pluginFactory.register(viewConnectionAddedPatchPlugin);
	pluginFactory.register(edgeConnectedPlugin);
	pluginFactory.register(edgeAddedPatchPlugin);
	pluginFactory.register(edgeRemovedPlugin);
	pluginFactory.register(nodeRemovedPlugin);
	pluginFactory.register(edgeKeepRootPlugin);
	pluginFactory.register(edgeVerticesPlugin);
	pluginFactory.register(edgeTerminalChangePlugin);
	pluginFactory.register(connectionRelationshipUpdatedPlugin);
	pluginFactory.register(connectionLabelUpdatedPlugin);
	pluginFactory.register(nodeDblclickPlugin);
	pluginFactory.register(historyNodeLabelPatchPlugin);
	pluginFactory.register(edgeDblclickPlugin);
	pluginFactory.register(connectionStartFromPlugin);
	pluginFactory.register(connectToolPlugin);
	pluginFactory.register(boardCopyPastePlugin);
}
